import { useEffect, useState } from 'react';

import { DockOutline, getDockOutline, subscribeDockOutline } from './dockCuePrefs';

/** Re-renders the strip when the A/B toggle flips, without a reload. */
export const useDockOutline = (): DockOutline => {
  const [v, setV] = useState<DockOutline>(getDockOutline);
  useEffect(() => subscribeDockOutline(() => setV(getDockOutline())), []);
  return v;
};
